export const LUCIUS_GROUP_ID = 'LUCIUS';

export interface TotalActiveGroup {
  userId?: string;
}

export interface ListAllGroup {
  userId?: string;
  distributorId?: string;
}

export interface ListAllDistributor {
  userId?: string;
  excludeDefault?: boolean;
}

export type UploadGroupCustomImageDTO = {
  groupId: string;
  formData: FormData;
};

export enum WatermarkPosition {
  TOP_LEFT = 'TOP_LEFT',
  TOP_CENTER = 'TOP_CENTER',
  TOP_RIGHT = 'TOP_RIGHT',
  CENTER = 'CENTER',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  BOTTOM_CENTER = 'BOTTOM_CENTER',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
}
